import { render } from "./ParcList.vue?vue&type=template&id=a36c70d2"
import script from "./ParcList.vue?vue&type=script&lang=js"
export * from "./ParcList.vue?vue&type=script&lang=js"

import "./ParcList.vue?vue&type=style&index=0&id=a36c70d2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__